import Separator from '../step-landing-page/Separator';
import { Step } from 'signup-constants/Step';
import { OAuthProviders } from './OAuthProviders';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useOAuthSignup } from './useOAuthSignup';
import { AppleButton } from '../apple/AppleButton';
import { GoogleOAuthButton } from '../google-authentication/GoogleOAuthButton';
import { MicrosoftButton } from '../microsoft/MicrosoftButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OAuthToComponent = {
  [OAuthProviders.Microsoft]: /*#__PURE__*/_jsx(MicrosoftButton, {}),
  [OAuthProviders.Google]: /*#__PURE__*/_jsx(GoogleOAuthButton, {}),
  [OAuthProviders.Apple]: /*#__PURE__*/_jsx(AppleButton, {})
};
export const OAuthSignupSection = ({
  shouldShowSeperator = true
}) => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const renderOAuths = () => {
    return Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    marginBlockStart: "400",
    children: [renderOAuths(), atLeastOneOAuthEnabled && shouldShowSeperator && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    })]
  });
};